$(document).ready(function() {


    var $form = $('.box');
    $form.addClass('has-advanced-upload');


    var $input    = $form.find('input[type="file"]');



        $form.on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
            e.preventDefault();
            e.stopPropagation();
        })
            .on('dragover dragenter', function() {
                $form.addClass('is-dragover');
            })
            .on('dragleave dragend drop', function() {
                $form.removeClass('is-dragover');
            })
            .on('drop', function(e) {
                //console.log(e.originalEvent.dataTransfer.files);
                $("input[type='file']").prop("files", e.originalEvent.dataTransfer.files);
                $form.addClass('has-file-attached');
                $('.file-info').text('File Attached');
            });



    $input.on('change', function(e) {
        $form.addClass('has-file-attached');
        $('.file-info').text('File Attached');
    });


});


// WEBPACK FOOTER //
// ./file-upload.js